import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { StorageService } from '@nohs/form-builder';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { environment } from './environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent {
  private router = inject(Router);
  private storage = inject(StorageService);

  constructor() {
    window.addEventListener('unauthorized', () => {
      this.storage.resetStorage();
      this.router.navigate(['/unauthorized']);
    });

    const angularPlugin = new AngularPlugin();
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsightsInstrumentationKey,
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: { router: this.router },
        },
      },
    });
    appInsights.loadAppInsights();
  }
}
